// --- Dot buttons ---

function initBtnDot(root) {
  (root || document).querySelectorAll('.btn-dot, .btn-dot-lg').forEach(function (btn) {
    if (btn._btnDotInit) return; // skip already-initialized buttons
    btn._btnDotInit = true;

    var circle = btn.querySelector('.btn-dot__circle');
    if (!circle) return;

    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      circle.style.left = e.clientX - rect.left + 'px';
      circle.style.top = e.clientY - rect.top + 'px';
    });

    btn.addEventListener('click', function () {
      circle.classList.add('btn-dot__circle--expanding');
    });

    btn.addEventListener('mouseleave', function () {
      circle.classList.remove('btn-dot__circle--expanding');
    });
  });
}

initBtnDot();

// --- Fixed CTA border ---

document.addEventListener('DOMContentLoaded', function () {
  var footer = document.querySelector('.footer');
  if (!footer) return;

  document.querySelectorAll('.fixed-cta').forEach(function (cta) {
    var observer = new IntersectionObserver(
      function (entries) {
        cta.classList.toggle('fixed-cta--border', entries[0].intersectionRatio >= 1);
      },
      { threshold: 1 }
    );
    observer.observe(footer);
  });
});
